<div class="loading" *ngIf="loader">Loading&#8230;</div>

    <div class="row no-gutters bot_spa_aft_sect_heading content_top_margin">
        <div class="col-12">
            <span class="sectionHeading_one">
                {{ 'income.titleTextBox' | translate }}
            </span>
        </div>
    </div>
    <div class="row no-gutters bot_spa_aft_sect_heading">
        <div class="col-12 d-flex align-items-center">
            <div id="incomeLabelTitle">
                <span *ngIf="currentLang == 'en'" class="pr-0">{{applicantName + " "}}</span>
                <ng-container *ngIf="preQualObj.users.length == 1">{{ 'income.grossIncomeTitle' | translate
                    }}</ng-container>
                <ng-container *ngIf="preQualObj.users.length == 2">{{ 'income.titleApplicant' | translate
                    }}</ng-container>
                <span *ngIf="currentLang == 'fr'">{{
                    " " + applicantName}}</span>
                <span class="whiteSpace" *ngIf="currentLang == 'en'">{{ 'income.income' | translate }}
                </span>
            </div>
                <span>
                    <button *ngIf="currentLang == 'en'" tabindex="0" type="button" id="btnttltip" class="pl-1 pr-0 infoButton"
                        aria-labelledby="emailTextAcc" (click)="$event.stopPropagation();openPopup()" #ert="ngbPopover"
                        [autoClose]="true" [ngbPopover]="popContent" placement="bottom">
                
                        <img aria-hidden="true" src="./assets/icons/helpIcon.svg" alt="helpIcon-icon" role="dialog">
                        <span class="show-for-sr" id="incomeTextAcc">{{'income.tootipClickInfo' | translate
                            }}</span>
                
                    </button>
                    <button *ngIf="currentLang == 'fr'" tabindex="0" type="button" id="btnttltip"
                        [attr.aria-expanded]="isIosDevice == true ? 'false' : null" class="pl-1 pr-0 infoButton"
                        aria-labelledby="emailTextAcc" (click)="$event.stopPropagation();openPopup()" #ert="ngbPopover"
                        [autoClose]="true" [ngbPopover]="popContent" placement="bottom">
                
                        <img aria-hidden="true" src="./assets/icons/helpIcon.svg" alt="helpIcon-icon" role="dialog">
                        <span class="show-for-sr" id="incomeTextAcc">{{'income.tootipClickInfo' | translate }}</span>
                
                    </button>
                </span>
        </div>
    </div>
    <div class="row no-gutters">
        <div class="col-md-5 col-lg-4 col-12">
            <input type="text" *ngIf="currentLang == 'en'" [readonly]="loader" class="wdd-fl border-cls" appMycurrency
                tabindex="0" [(ngModel)]="incomeObj.income"
                [ngClass]="isSelected==false?'nonSelectBorder':'selectBorder'"
                (keyup)="validationamout(incomeObj.income)" id="inputIncome" aria-labelledby="incomeLabelTitle"
                aria-describedby="emailHelp" aria-required="true" autocomplete="off" (focus)="isSelected=true"
                (blur)="isSelected=false" maxlength="9">
            <div class="input-wrapper" *ngIf="currentLang == 'fr'">
                <input type="text" [readonly]="loader" class="wdd-fl border-cls" appMycurrencyFr tabindex="0"
                    (keyup)="validationamoutFr(incomeObj.income)" [(ngModel)]="incomeObj.income"
                    [ngClass]="isSelected==false?'nonSelectBorder':'selectBorder'" id="inputIncome"
                    aria-labelledby="incomeLabelTitle" aria-describedby="emailHelp" aria-required="true"
                    autocomplete="off" (focus)="isSelected=true" (blur)="isSelected=false" maxlength="7">
                <div class="iconAlignT">
                    <span id="basic-addon2">$</span>
                </div>
            </div>
        </div>
    </div>
    <div class="row no-gutters top_spa_aft_sect_heading">
        <div class="col-12">
    <small id="emailHelp" *ngIf="isValid && colorForTb" class="d-flex align-items-start mt-1 errorMsg"> <img
            src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2">
            {{ 'income.errormsg' | translate }}
        </span>
    </small>
    <small id="emailHelp" *ngIf="!colorForTb" class="d-flex align-items-start mt-1 errorMsg"> <img
            src="./assets/images/menu_icons/Alert.svg" alt=""> <span class="ml-2">
            {{ 'income.errormsg' | translate }}
        </span>
    </small>
        </div>
    </div>
    <div class="row no-gutters top_height_actionButton content_top_mobile_margin">
        <div class="col-12 d-flex d-md-block flex-column-reverse">
            <cancel-button></cancel-button>
            <button type="button" class="common_btn saveNextBtn_features space_between_button"
                (click)="onContinue()">{{'buttonallpages.continuelable' | translate }}</button>
        </div>
    </div>

<ng-template #popContent class="popContent">
    <div role="dialog" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" class="tooltip-content">
        <div>

        </div>
        <button type="button" class="close closettp" id="clsTooltipa" data-dismiss="modal"
            aria-label="Close" data-toggle="tooltip" data-placement="top">

            <span class="popUpClose" aria-hidden="true">&times;</span>

            <span class="show-for-sr">{{'persInfo.close' | translate}}</span>
        </button>
        <div class="modal-body p-3">{{ 'income.incomecoborrowersonamortgage' | translate }}
        </div>
    </div>
</ng-template>